import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { map, Observable } from "rxjs";
import { Provider } from "../../models/provider/provider.model";
import { ProviderProfile } from "../../models/provider/provider-profile.model";

@Injectable({
    providedIn: 'root'
})
export class ProviderService {

    constructor(private http: HttpClient) {}

    getByGuid(providerGuid: string): Observable<Provider> {
        const url = `${environment.provider.root}/${providerGuid}`;
        return this.http.get<{ provider: Provider }>(url, { withCredentials: true }).pipe(
            map(response => response.provider)
        );
    }
  
    getByPersonGuid(personGuid: string): Observable<Provider> {
        const url = `${environment.provider.root}/bypersonguid/${personGuid}`;
        return this.http.get<{provider: Provider}>(url, { withCredentials: true }).pipe(
            map(response => response.provider)
        );
    }

    create(payload: Partial<Provider>): Observable<Provider> {
        const url = `${environment.provider.root}`;
        return this.http.post<Provider>(url, payload, { withCredentials: true });
    }

    update(providerGuid: string, payload: Partial<Provider>): Observable<Provider> {
        const url = `${environment.provider.root}/${providerGuid}`;
        return this.http.put<Provider>(url, payload, { withCredentials: true });
    }

    getProfile(providerGuid: string): Observable<ProviderProfile> {
        const url = `${environment.provider.root}/${providerGuid}/profile`;
        return this.http.get<{ profile: ProviderProfile }>(url, { withCredentials: true }).pipe(
            map(response => response.profile)
        );
    }

    updateProfile(providerGuid: string, payload: Partial<ProviderProfile>): Observable<Provider> {
        const url = `${environment.provider.root}/${providerGuid}/profile`;
        return this.http.put<{ provider: Provider }>(url, payload, { withCredentials: true }).pipe(
            map(response => response.provider)
        );
    }

    delete(providerGuid: string): Observable<void> {
        const url = `${environment.provider.root}/${providerGuid}`;
        return this.http.delete<void>(url, { withCredentials: true });
    }

    verify(providerGuid: string): Observable<Provider> {
        const url = `${environment.provider.root}/${providerGuid}/verify`;
        return this.http.patch<Provider>(url, {}, { withCredentials: true });
    }
}
